import { LayoutConfig } from '@spartacus/storefront'

export const ebMyAccountLayoutConfig: LayoutConfig = {
  layoutSlots: {
    AccountPageTemplate: {
      slots: ['TopContent', 'BodyContent', 'SideContent']
    }
  }
}
